enum ChatContextInteractionType {
  SinPlayer = 'Sin Player',
  BanPlayer = 'Ban Player',
  TechnicalReferral = 'Technical Referral',
  SafePlayReferral = 'SafePlay Referral',
  CommunityNomination = 'Community Nomination'
}

export { ChatContextInteractionType };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/chat-context-menu/chat-context-interaction-type.ts